/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import homePage from './homePage'
import myService from './myService'
import serviceChannel from './serviceChannel'
import homePageSetting from './homePageSetting'
import historyRecord from './historyRecord'

export default [
  ...homePage,
  ...myService,
  ...serviceChannel,
  ...homePageSetting,
  ...historyRecord
]



// WEBPACK FOOTER //
// ./src/router/page/personalCenter/index.js